import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import dateService from '@/services/date-service';
import store from '@/store';
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/monthOfEmployees',
        name: 'MonthOverView',
        component: () => import(/* webpackChunkName: "monthofemployees" */ '../modules/month/overview/components/MonthOverView'),
        meta: { moduleId: 'monthOfEmployees' },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/reopenMonth',
        name: 'ReopenMonthView',
        component: () => import(/* webpackChunkName: "reopenMonth" */ '@/modules/month/reopen/ReopenMonthView'),
        meta: { moduleId: 'reopenMonth' },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthlyVerification',
        name: 'MonthlyVerificationView',
        component: () => import(/* webpackChunkName: "monthlyVerificationView" */ '../modules/month/MonthlyVerificationView'),
        meta: { 
            moduleId: 'monthlyVerificationView',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/absence',
        name: 'MonthlyAbsenceView',
        component: () => import(/* webpackChunkName: "MonthAbsenceView" */ '@/modules/month/overview/components/MonthlyAbsenceView'),
        meta: { 
            moduleId: 'monthlyAbsence',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
    },
    {
        path: '/monthlyAbsenceConfiguration',
        name: 'MonthlyAbsenceConfigurationView',
        component: () => import(/* webpackChunkName: "MonthlyAbsenceConfigurationView" */ '@/modules/month/overview/components/MonthlyAbsenceConfiguration'),
        meta: { 
            moduleId: 'monthlyAbsenceConfiguration',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
    },
    {
        path: '/calendar',
        name: 'CalendarView',
        component: () => import(/* webpackChunkName: "calendarView" */ '@/modules/month/calendar/CalendarView'),
        meta: { moduleId: 'monthCalendar' },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/balancechange',
        name: 'monthBalanceOverview',
        component: () => import(/* webpackChunkName: "monthBalanceOverview" */ '@/modules/month/overview/components/MonthBalanceOverView'),
        meta: {
            moduleId: 'monthBalanceOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/balancechange/:id',
        name: 'BalanceChangeForm',
        component: () =>
            import(
            /* webpackChunkName: "BalanceChangeForm" */ '@/modules/month/overview/components/BalanceChangeForm'
            ),
        meta: {
            moduleId: 'monthBalanceOverview',
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthstatus',
        name: 'MonthStatusView',
        component: () => import(/* webpackChunkName: "monthStatusView" */ '../modules/month/status/MonthStatusView'),
        meta: { 
            moduleId: 'monthstatus',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthConfirmation',
        name: 'monthConfirmationOverView',
        component: () => import(/* webpackChunkName: "monthConfirmation" */ '../modules/month/confirmation/components/MonthConfirmation'),
        meta: {
            moduleId: 'monthConfirmation'
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthly-employee-project-progress',
        name: 'MonthlyEmployeeProgressView',
        component: () => import(/* webpackChunkName: "monthlyEmployeeProgressView" */ '../../src/modules/month/MonthlyEmployeeProgressView'),
        meta: { 
            moduleId: 'monthlyEmployeeProgress',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter(to, from, next) {
            if (!to.query?.id) {
                const actingUserDetails = store.getters['actingUser/getActingUserDetails'];
                const employeeId = actingUserDetails?.employeeId;

                if (employeeId) {
                    const newRoute = {
                        ...to,
                        from,
                        query: {
                            ...to.query,
                            id: employeeId
                        }
                    };
                    return next(newRoute);
                }
            }
            checkLinkedEmployee(to, from, next);
        },
    },
    {
        path: '/workinghoursimport',
        name: 'WorkingHoursImportView',
        component: () => import(/* webpackChunkName: "working-hours-import" */ '../modules/timetracking/components/workingHours/WorkingHoursImportView'),
        meta: {
            moduleId: 'workinghoursimport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/openProcesses',
        name: 'OpenProcessesView',
        component: () => import(/* webpackChunkName: "open-processes" */ '../modules/timetracking/components/openProcesses/OpenProcessesView'),
        meta: {
            moduleId: 'openProcesses',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
]
